import { range } from "lodash"
import { log } from "../../../../common/Logging"
import { Sprites } from "../../../utils/Sprites"
import { WomAtlas, WomAudio } from "../WheelOfMisfortuneAssets"
import { WheelOfMisfortuneState } from "../WheelOfMisfortuneState"
import { spinConfigs, WheelSlice, WheelValues } from "../WheelOfMisfortuneType"

export class WheelSprite {
    spin: Phaser.Tween
    stop: Phaser.Tween
    game: Phaser.Game
    wheel: Phaser.Sprite
    state: WheelOfMisfortuneState
    beyondDuration = false
    degreeValues: Array<number>
    spinning: Phaser.Sound
    winSound: Phaser.Sound
    loseSound: Phaser.Sound
    spinNumber = 0
    bonus: boolean

    constructor(game: Phaser.Game, state: WheelOfMisfortuneState) {
        this.game = game
        this.state = state

        this.wheel = Sprites.add(game, WomAtlas.WHEELS)
        this.wheel.anchor.set(0.5, 0.5)
        this.degreeValues = range(0, 360, 22.5)
        this.spin = this.game.add.tween(this.wheel)
        this.stop = this.game.add.tween(this.wheel)
        this.spinning = this.game.add.sound(WomAudio.SPINNING)
        this.winSound = this.game.add.sound(WomAudio.REWARD_BELL)
        this.loseSound = this.game.add.sound(WomAudio.ADDICTION_BUZZER)
    }

    stopSpin = () => {
        if (this.spin.isRunning) {
            this.state.stopButton.disable()
            this.spin.stop()
            this.stop.start()
        }
    }

    spinWheel = (round: number) => {
        if (!this.spin.isRunning) {
            if (this.spinNumber < 7) {
                this.state.smokeButton.disable()
                this.state.stopButton.enable()
                let index: number
                if (this.bonus || this.spinNumber === 5) {
                    index = this.forceLoss(spinConfigs[this.spinNumber])
                    if (this.bonus) {
                        this.bonus = false
                    }
                } else {
                    index = this.game.rnd.between(0, 15)
                }

                const degrees = this.degreeValues[index]
                const selectedSlice = spinConfigs[this.spinNumber][index]

                const timer = this.game.time.create(true)
                timer.add(3000, () => {
                    this.state.stopButton.disable()
                    this.beyondDuration = true
                })

                this.spin = this.game.add.tween(this.wheel).to({angle: 360 * 4 + degrees}, 7000, Phaser.Easing.Quadratic.Out, true)
                this.stop = this.game.add.tween(this.wheel).to({angle: 360 + degrees}, 2000, Phaser.Easing.Quadratic.Out)
                this.spin.onStart.add(() => {
                    timer.start()
                    this.spinning.play()
                })
                const onComplete = () => this.onWheelSpinComplete(selectedSlice, round)
                this.spin.onComplete.add(onComplete)
                this.stop.onComplete.add(onComplete)
            }
        }
    }

    playChangeAudio = (round: number) => {
        const change = this.game.add.audio(this.getChangeAudio(round))
        change.onPlay.addOnce(() => {
            this.game.add.tween(this.wheel).to({angle: 0}, 1000, Phaser.Easing.Quadratic.Out, true)
            this.spinNumber += 1
            this.wheel.frame = this.spinNumber
            this.state.arrow.rotateUp()
        })
        change.onStop.addOnce(() => this.state.arrow.rotateDown(this.state.enableSideButtons))
        change.play()
    }

    resetWheel = () => {
        this.spinNumber = 0
        this.wheel.angle = 0
    }

    hide = () => this.wheel.visible = false

    view = () => this.wheel.visible = true

    private onWheelSpinComplete = (selectedSlice: WheelSlice, round: number) => {
        if (selectedSlice.value === WheelValues.NOT_ADDICTED) {
            this.winSound.onStop.addOnce(() => this.onSpinWin(round))
            this.winSound.play()
        } else {
            this.loseSound.onStop.addOnce(this.onSpinLose)
            this.loseSound.play()
        }

        this.state.scoreText.calculateScore(selectedSlice.points)
        this.beyondDuration = false
    }

    private onSpinWin = (round: number) => {
        const narrator = this.game.add.audio(this.getNarratorWinAudio(round))
        narrator.onStop.addOnce(() => {
            if (round > 1 && this.spinNumber === 3) {
                this.state.bonusScreen()
            } else {
                this.playChangeAudio(round)
            }
        })
        narrator.play()
    }

    private forceLoss = (wheel: Array<WheelSlice>): number => {
        const addictedIndices: Array<number> = []
        wheel.forEach((slice, index) => {
            if (slice.value === WheelValues.ADDICTED) {
                addictedIndices.push(index)
            }
        })
        log.debug("Forcing loss.")
        return addictedIndices[Math.floor(Math.random() * addictedIndices.length)]
    }

    private onSpinLose = () => {
        const narrator = this.game.add.audio(this.getLossAudio())
        narrator.onStop.addOnce(() => {
            this.state.disableSideButtons()
            this.state.gameOverScreen()
        })
        narrator.play()
    }

    private getNarratorWinAudio = (round: number) =>
        (round < 3) ? `round-${round}-spin-${this.spinNumber + 1}.mp3` : `round-1-spin-${this.spinNumber + 1}.mp3`

    private getChangeAudio = (round: number): string =>
        (round < 3) ? `round-${round}-change-${this.spinNumber + 1}.mp3` : `round-1-change-${this.spinNumber + 1}.mp3`

    private getLossAudio = (): string => `loss-${this.spinNumber + 1}.mp3`
}